import Glide, {
  Autoplay,
  Breakpoints,
  Controls,
  Swipe,
} from "@glidejs/glide/dist/glide.modular.esm"

/**
 * @param selector - The selector of the glide element.
 * @param options
 * @param options.perView - The number of slides to show at once. Default is 3
 * @param options.bulletClass - The class to add to the active bullet. Default is "bg-blue-30-primary!"
 * @param options.autoplay - Whether to autoplay the slider. Default is true
 */
export const initializeGlide = (selector, {
  perView = 3,
  bulletClass = "bg-blue-30-primary!",
  autoplay = true,
} = {}) => {
  const glide = new Glide(selector, {
    startAt: 0,
    perView: perView,
    autoplay: 5000,
    breakpoints: {
      1300: {
        perView: 1,
      },
    },
    focusAt: "center",
    type: "carousel",
  })

  glide.on(["mount.after", "run"], function () {
    updateActiveBullet(glide.index, bulletClass)
  })

  autoplay ? glide.mount({ Controls, Breakpoints, Autoplay }) : glide.mount({ Controls, Breakpoints })
}

export const initializeSlider = () => {
  const glide = new Glide(".glide", {
    startAt: 0,
    perView: 3,
    breakpoints: {
      500: {
        perView: 1,
        peek: 0,
      },
      768: {
        perView: 1,
        peek: 100,
      },
      1024: {
        perView: 2,
        peek: 150,
      },
    },
    peek: 200,
    focusAt: "0",
    type: "slider",
    rewind: false,
  })

  glide.mount({ Controls, Breakpoints, Swipe })
}

function updateActiveBullet(index, bulletClass) {
  document.querySelectorAll(".glide__bullet").forEach((bullet) => {
    const bulletIndex = parseInt(bullet.getAttribute("data-index"))
    if (bulletIndex === index) {
      bullet.classList.add(bulletClass)
    } else {
      bullet.classList.remove(bulletClass)
    }
  })
}
